import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { IModalData } from "../edp-modal.models";

@Component({
    selector: "edp-modal-confirm",
    templateUrl: "./edp-modal-confirm.component.html",
    styleUrls: ["./edp-modal-confirm.component.scss"]
})
export class EdpModalConfirmComponent {
    @Input() public data: IModalData;

    constructor(
        public translate: TranslateService
    ) { }

    public close(): void {
        this.data.service.close(true);
    }

    public dismiss(): void {
        this.data.service.dismiss(false);
    }
}
